import { render, staticRenderFns } from "./QualificationDiscipline.vue?vue&type=template&id=2d2e9dc4&"
import script from "./QualificationDiscipline.vue?vue&type=script&lang=js&"
export * from "./QualificationDiscipline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports